import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default function usePing() {
  const [latency, setLatency] = useState<number>(0);

  const ping = () => {
    rpc
      .callServer("ping", { date: new Date() })
      .then((response) => {
        console.log("SERVER CALLED PING", { response }, latency);
      })
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    // ping();
    rpc.register("pong", (args) => {
      const newlatency = new Date().getTime() - new Date(args.date).getTime();
      setLatency(newlatency);
      setTimeout(ping, 1000);
    });
  }, []);

  return {
    latency,
  };
}
